import React from 'react';
import { Page, Header, Content } from '@backstage/core-components';
import BreadcrumbsNav from '../../common/BreadcrumbsNav/BreadcrumbsNav';
import LeaderBoardPage from '../../leaderBoard/leaderBoardContainer';

export const DevXLeaderboardPage = () => {
  const routes = [
    {
      path: '/',
      title: 'Home',
    },
    {
      path: '/leaderboard/devx',
      title: 'DevX Leaderboard',
    },
  ];

  return (
    <Page themeId="home">
      <Header
        title="DevX Leaderboard"
        pageTitleOverride="DevX Leaderboard"
        subtitle={<BreadcrumbsNav lastRoutes={routes} skipLast={false} />}
      />
      <Content>
        <LeaderBoardPage
          isAdhocPointPage={false}
          onclickHandler={() => {}}
        />
      </Content>
    </Page>
  );
};
